import * as angular from 'angular';
import * as _ from 'lodash';

import { TileConfiguration } from './tileWidget.configuration';
import { DataWidgetBase, IdataWidget } from '../../widgets';
import { IwidgetIntervalHelperService } from '../../services';
import { WidgetValuesReadConfiguration, IPeriodConfiguration, ReadType, IBindable, ITileSerieConfiguration, AggregationConfiguration, WidgetValues, IValueViewModel } from '../../models';
import { Helper } from '../../common';
import { tileWidgetDefinition as definition } from './tileWidget.definition';

export class TileWidget extends DataWidgetBase implements IdataWidget {
    baseType = definition.baseType;
    col = 0;
    configuration: TileConfiguration;
    exportFormats = ['csv'];
    exportToCsv: ()=> angular.IPromise<any>;
    guid: string;
    hasExtendedProperties = true;
    highlights = definition.highlights;
    icon = definition.icon;
    isExportable = true;
    name = definition.title;
    row = 0;
    sizeX = 6;
    sizeY = 18;
    type = definition.type;

    constructor(private _$q: angular.IQService,
        widgetIntervalHelperService: IwidgetIntervalHelperService) {
        super(widgetIntervalHelperService);
        this.guid = Helper.getGuid();

        this.configuration = {
            hasTimeRange: true,
            dateFormat: '',
            aggregationMode: 1
        };
    }

    getReadConfiguration(beginDate: string, endDate: string): WidgetValuesReadConfiguration {
        const aggreg = { mode: this.configuration.aggregationMode } as AggregationConfiguration;
        const series = this.getSeriesList();
        const hasAlarms = _.some(series, s => s.hasAlarm);

        const config = this.getReadConfigurationBase(
            beginDate, endDate, series,
            this.configuration as IPeriodConfiguration,
            aggreg, false, false, false, false, false, ReadType.AggregatedValue, hasAlarms);

        return config;
    }

    private getSeriesList(): IBindable[] {
        let result = [];
        if (this.configuration && this.configuration.series) {
            result = _.filter(this.configuration.series, s => s.selection === 'value')
                .map((d: ITileSerieConfiguration) => {
                    return {
                        guid: d.guid,
                        value: d.valueType,
                        hasAlarm: d.showAlarm,
                        isBoundToGroup: d.isBoundToGroup
                    };
                });
        }
        return result;
    }

    getReadConfigurationAsync(): angular.IPromise<WidgetValuesReadConfiguration> {
        const hasQuality = false;
        const hasMissingRanges = true;
        const hasContext = false;
        const hasTendency = false;
        const hasTarget = false;
        const aggregation = { mode: this.configuration.aggregationMode } as AggregationConfiguration;

        const result = this.createConfiguration(
            this.getSeriesList(), aggregation, hasQuality, hasMissingRanges, hasContext, hasTendency, hasTarget
        );

        return this._$q.when(result);
    }
}